import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { first } from 'rxjs/operators';

import { routerPublicCommands } from '@frontend/libs/duttirouter';
import { GoToSection } from '@shared/navigation/store/navigation.actions';
import { getUserSelector } from '@shared/user/store/user.selectors';

@Injectable()

/**
 * Guard de protección de rutas autenticadas
 */
export class AuthGuard {
    constructor(
        private readonly store: Store,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // Obtén el usuario de la Store
        return this.store.select(getUserSelector).pipe(
            first(user => !!user),
            map(user => {
                if (user.userType !== 'G') {
                    return true;
                }
                this.store.dispatch(routerPublicCommands.SaveHistory({ url: state.url }));
                this.store.dispatch(GoToSection({ url: 'userLoginApolo' }));
                return false;
            }),
        );
    }
}
